import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://xfwfcfihwqkqvwfjykly.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inhmd2ZjZmlod3FrcXZ3Zmp5a2x5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODQ1ODUxMTEsImV4cCI6MjEwMDE2MTExMX0.0EXO9Ug_0xf1qnBREcP6NrpvScGq3rLdPS7I5qu1ttU'

if(!SUPABASE_URL || !SUPABASE_ANON_KEY ){
  throw new Error('Missing Supabase variables');
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})